export default "__VITE_ASSET__DlFEUxSz__"